export const residencyTaxContext = {
    monthlyRendPaidStates: [],
    monthlyRendPaid: '',
    showMassachusettsInsurance: '',
    massachusettsInsurance: '',
    showselfspouseReside: '',
    selfspouseReside: '',
    showLicenseOrStateId: '',
    licenseOrStateId: ''
}
export const residencyEmptyContextTaxPayer = { taxYear: "", state: "", startDate: "", endDate: "", taxPayer: "",type: "1" }
export const residencyEmptyContextSpouse = { taxYear: "", state: "", startDate: "", endDate: "", taxPayer: "", type: "2" }


export const taxYearOptions = [
    {
        value: 2026,
        label: "2026",
    },
    {
        value: 2025,
        label: "2025",
    },
    {
        value: 2024,
        label: "2024",
    },
    {
        value: 2023,
        label: "2023",
    },
    {
        value: 2022,
        label: "2022",
    },
    {
        value: 2021,
        label: "2021",
    },
]

export const stateOptions = [
    {
        value: "Alabama",
        label: "Alabama",
    },
    {
        value: "Alaska",
        label: "Alaska",
    },
    {
        value: "Arizona",
        label: "Arizona",
    },
    {
        value: "Arkansas",
        label: "Arkansas",
    },
    {
        value: "Australia",
        label: "Australia",
    },
    {
        value: "California",
        label: "California",
    },
    {
        value: "Canada",
        label: "Canada",
    },
    {
        value: "Colorado",
        label: "Colorado",
    },
    {
        value: "Connecticut",
        label: "Connecticut",
    },
    {
        value: "District of Columbia",
        label: "District of Columbia",
    },
    {
        value: "Delaware",
        label: "Delaware",
    },
    {
        value: "Florida",
        label: "Florida",
    },
    {
        value: "Georgia",
        label: "Georgia",
    },
    {
        value: "Hawaii",
        label: "Hawaii",
    },
    {
        value: "Idaho",
        label: "Idaho",
    },
    {
        value: "Illinois",
        label: "Illinois",
    },
    {
        value: "Indiana",
        label: "Indiana",
    },
    {
        value: "India",
        label: "India",
    },
    {
        value: "Iowa",
        label: "Iowa",
    },
    {
        value: "Kansas",
        label: "Kansas",
    },
    {
        value: "Kentucky",
        label: "Kentucky",
    },
    {
        value: "Louisiana",
        label: "Louisiana",
    },
    {
        value: "Maine",
        label: "Maine",
    },
    {
        value: "Maryland",
        label: "Maryland",
    },
    {
        value: "Massachusetts",
        label: "Massachusetts",
    },
    {
        value: "Mexico",
        label: "Mexico",
    },
    {
        value: "Michigan",
        label: "Michigan",
    },
    {
        value: "Minnesota",
        label: "Minnesota",
    },
    {
        value: "Mississippi",
        label: "Mississippi",
    },
    {
        value: "Missouri",
        label: "Missouri",
    },
    {
        value: "Montana",
        label: "Montana",
    },
    {
        value: "Nebraska",
        label: "Nebraska",
    },
    {
        value: "Nevada",
        label: "Nevada",
    },
    {
        value: "New Hampshire",
        label: "New Hampshire",
    },
    {
        value: "New Jersey",
        label: "New Jersey",
    },
    {
        value: "New Mexico",
        label: "New Mexico",
    },
    {
        value: "New York",
        label: "New York",
    },
    {
        value: "North Carolina",
        label: "North Carolina",
    },
    {
        value: "North Dakota",
        label: "North Dakota",
    },
    {
        value: "Ohio",
        label: "Ohio",
    },
    {
        value: "Oklahoma",
        label: "Oklahoma",
    },
    {
        value: "Oregon",
        label: "Oregon",
    },
    {
        value: "Pennsylvania",
        label: "Pennsylvania",
    },
    {
        value: "Rhode Island",
        label: "Rhode Island",
    },
    {
        value: "South Carolina",
        label: "South Carolina",
    },
    {
        value: "South Dakota",
        label: "South Dakota",
    },
    {
        value: "Tennessee",
        label: "Tennessee",
    },
    {
        value: "Texas",
        label: "Texas",
    },
    {
        value: "Utah",
        label: "Utah",
    },
    {
        value: "Vermont",
        label: "Vermont",
    },
    {
        value: "Virginia",
        label: "Virginia",
    },
    {
        value: "Washington",
        label: "Washington",
    },
    {
        value: "West Virginia",
        label: "West Virginia",
    },
    {
        value: "Wisconsin",
        label: "Wisconsin",
    },
    {
        value: "Wyoming",
        label: "Wyoming",
    },
]